var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Btn',{staticClass:"BtnApproval ib sm",class:{
    danger: !_vm.isApproved && _vm.shouldApprove,
    success: _vm.isApproved || !_vm.shouldApprove,
    inv: !_vm.isApproved,
  },attrs:{"icon":_vm.isApproved ? 'check' : null},on:{"click":_vm.toggleApprovedAt}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }